import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { AuthService } from '@core';
import { environment } from '@env/environment';

/**
 * Redirects non-admin users to `environment.defaultUserRoute` (e.g. /dossier).
 * Admin users pass through unaffected.
 * If `defaultUserRoute` is not configured, the guard allows all users through.
 */
export const userRedirectGuard: CanActivateFn = () => {
  const defaultUserRoute = environment.defaultUserRoute;
  if (!defaultUserRoute) {
    return true;
  }

  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.user().pipe(
    take(1),
    map(user => {
      if (user?.roles?.includes('admin')) {
        return true;
      }
      return router.createUrlTree([defaultUserRoute]);
    })
  );
};
